let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8dhqQ")).then(() => parcelRequire('5i4s6'));